import Dexie, { type EntityTable } from 'dexie'

/**
 * Lokale Datenbank der App.
 *
 * Hier liegt alles, was einen Neustart und ein Funkloch überleben muss: die PDFs
 * selbst, die Favoriten, der Verlauf und die Einstellungen. Der Service Worker
 * kümmert sich nur um die Programmhülle und den Katalog — die PDFs verwaltet die
 * App bewusst selbst, weil sie einzeln nachgeladen und verdrängt werden können
 * müssen.
 */

export interface StoredPdf {
  /** Karten-ID. */
  id: string
  /**
   * PDF-Inhalt als ArrayBuffer. Bewusst kein Blob: Blobs in IndexedDB sind je nach
   * Browser und Speicherdruck nicht zuverlässig persistent, ArrayBuffer sind es.
   */
  data: ArrayBuffer
  /** SHA-256 laut Katalog zum Zeitpunkt des Downloads — Grundlage der Update-Erkennung. */
  hash: string
  bytes: number
  storedAt: number
  /** Letzter Zugriff; steuert die Verdrängung, wenn der Speicher knapp wird. */
  lastUsedAt: number
}

export interface FavoriteEntry {
  id: string
  /** Position in der Favoritenliste; kleinere Werte zuerst. */
  position: number
  addedAt: number
}

export interface HistoryEntry {
  id: string
  openedAt: number
}

export interface SettingEntry {
  key: string
  value: unknown
}

/** Zwischengespeicherter Katalog — Rückfallebene, solange der Service Worker fehlt. */
export interface CachedCatalog {
  key: 'catalog'
  json: string
  fetchedAt: number
}

const db = new Dexie('taschenkarten') as Dexie & {
  pdfs: EntityTable<StoredPdf, 'id'>
  favorites: EntityTable<FavoriteEntry, 'id'>
  history: EntityTable<HistoryEntry, 'id'>
  settings: EntityTable<SettingEntry, 'key'>
  catalogCache: EntityTable<CachedCatalog, 'key'>
}

db.version(1).stores({
  pdfs: 'id, hash, lastUsedAt',
  favorites: 'id, position',
  history: 'id, openedAt',
  settings: 'key',
  catalogCache: 'key',
})

export { db }
